import Component from '../../components/component/component';

import './numpad.scss';

export default class Numpad extends Component {
    static initSelector: string = '.numpad';

    currentState: string = '';
    input: HTMLInputElement;
    form: HTMLFormElement;

    buttons: HTMLCollectionOf<Element>;
    cancelButton: HTMLCollectionOf<Element>;

    tipConfirmButton: HTMLElement;
    id: string;

    constructor(target: HTMLElement) {
        super(target);

        this.id = this.element.id;
        this.input = document.getElementById(`${this.id}-numpad-state`) as HTMLInputElement;
        this.form = document.getElementById(this.id) as HTMLFormElement;
        this.buttons = this.form.getElementsByClassName('numpad__button');
        this.cancelButton = this.form.getElementsByClassName('numpad__cancel-button');
        document.addEventListener('keyup', this.onKeyboardClick.bind(this));
        this.tipConfirmButton = this.element.querySelector('.js-confirm-tip');

        this.init();
    }

    init(): void {
        Array.from(this.buttons).forEach((button: HTMLElement) => {
            button.addEventListener('click', this.onButtonClick.bind(this));
        });

        if (this.tipConfirmButton) {
            this.tipConfirmButton.addEventListener('click', this.onSubmit.bind(this));
        }
    }

    onSubmit(): void {
        const submitButton: HTMLCollectionOf<HTMLButtonElement> = this.form.getElementsByClassName('numpad__submit-btn') as HTMLCollectionOf<HTMLButtonElement>;

        Array.from(submitButton)[0].click();
    }

    onButtonClick(event: MouseEvent): void {
        const number: string = (event.currentTarget as HTMLButtonElement).dataset.number;

        switch (number) {
            case 'placeholder':
                return;
            case 'back':
                return this.updateState(this.currentState.slice(0, this.currentState.length - 1));
            default:
                return this.updateState(this.currentState + number);
        }
    }

    onKeyboardClick(event: KeyboardEvent): void {
        const eventKey: KeyboardEvent['key'] = event.key;
        const isNumber: boolean = !isNaN(parseInt(eventKey));

        if (isNumber) {
            this.updateState(this.currentState + parseInt(eventKey));
        }

        if (eventKey === 'Backspace') {
            this.updateState(this.currentState.slice(0, this.currentState.length - 1));
        }
    }

    updateState(pin: string): void {
        this.currentState = pin;
        this.input.value = this.currentState;
        this.updateDisplay();

        if (!this.element.classList.contains('numpad--tip')) {
            if (this.currentState.length >= this.element.getElementsByClassName('numpad__slot').length) {
                this.currentState = this.currentState.slice(0, this.element.getElementsByClassName('numpad__slot').length);
                this.onSubmit();
            }
        }
    }

    updateDisplay(): void {
        if (this.element.classList.contains('numpad--tip')) {
            const inputField: HTMLInputElement = this.element.getElementsByClassName('numpad__tip-input')[0] as HTMLInputElement;

            inputField.value = this.currentState;
        } else {
            Array.from(this.element.getElementsByClassName('numpad__slot')).forEach((element: HTMLElement) => {
                element.textContent = '';
            });

            Array.from(this.currentState).forEach((string: string, index: number) => {
                const slot: HTMLCollectionOf<Element> = this.element.getElementsByClassName('numpad__slot--' + (index + 1));

                if (slot[0]) {
                    slot[0].textContent = string;
                }
            });
        }
    }

}
